import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const LegalLinksContainer = styled.div`
  margin-top: ${props => props.theme.space.s9};
  display: flex;
  justify-content: center;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
`;

export const CopyrightLink = styled(Link)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  font-family: ${props => props.theme.fonts.circular};
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
  display: inline-block;

  &:not(:last-of-type):after {
    content: '\\007C';
    color: ${props => props.theme.colors.capsuleGray10};
    margin: 0 0.6rem;
    display: inline-block;
  }
`;
